import React, {useState, useEffect, useRef} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import parser from 'html-react-parser';

import ProgressiveImg from '../components/ProgressiveImg';

import '../assets/styles/pages/_products-page.scss'
import questionsActions from "../store/actions/questions";

export const Products = ({ productData }) => {
  const questionsStore = useSelector((store) => store.questionsStore);
  const dispatch = useDispatch();

  const toggleOpen = (item) => {
    if (item.parentNode.classList.contains('open')){
      item.parentNode.classList.remove('open');
    } else {
      item.parentNode.classList.add('open');
    }
  }

  useEffect(() => {
    dispatch(questionsActions.fetchQuestions('common', productData.questionsId));
  }, [productData]);

  return (
    <>
      <div className="products-page">

        <div className={`products-block-1 ${productData.block_1?.className ? productData.block_1.className : ''}`}>
          <ProgressiveImg
            lowQualitySrc={productData.block_1.rightPictureLow}
            highQualitySrc={productData.block_1.rightPicture}
            className="right-picture"
            style={{
              width: productData.block_1.rightPicWidth,
              //top: productData.block_1.rightPicTop
            }}
          />
          <ProgressiveImg
            lowQualitySrc={productData.block_1.leftPictureLow}
            highQualitySrc={productData.block_1.leftPicture}
            className="left-picture"
            style={{
              width: productData.block_1.leftPicWidth,
              //top: productData.block_1.leftPicTop
            }}
          />
          <div className="container">
            <div className="title">
              { productData.block_1.title }
            </div>
            <div className="undertitle">
              { productData.block_1.undertitle }
            </div>
            <Link to="/find-an-agent" className='action-btn-link'>
              <button className='action-btn button-gradient'>
                Find an Agent
              </button>
            </Link>
          </div>
        </div>

        <div className="products-block-2" style={{marginTop: 0}}>
          <div className="container">
            <div className="title">
              { productData.block_2.title }*
            </div>
            {
              productData.block_2.undertitle &&
              <div className="undertitle">
                { productData.block_2.undertitle || '' }
              </div>
            }
            {
              productData.block_2.block2_1 &&
              <div className="cards-block">
                {
                  productData.block_2.block2_1.map(item => {
                    return (
                      <div className="products-card" key={item.id}>
                        <div className="top-line">
                          <div className="icon">
                            <img src={item.img} alt="" />
                          </div>
                          <div className="card-title">
                            {item.title}
                          </div>
                        </div>
                        <div className="bottom-line">
                          <div className="text">
                            {item.text}
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            }
            {
              productData.block_2.undertitle2 &&
              <div className="undertitle">
                { productData.block_2.undertitle2 || '' }
              </div>
            }

            <div className="cards-block">
              {
                !productData.block_2.block2_2 ?
                '' :
                productData.block_2.block2_2.map(item => {
                  return <div className="products-card" key={item.id}>
                    <div className="top-line">
                      <div className="icon">
                        <img src={item.img} alt="" />
                      </div>
                      <div className="card-title">
                        {item.title}
                      </div>
                    </div>
                    <div className="bottom-line">
                      <div className="text">
                        {item.text}
                      </div>
                    </div>
                  </div>
                })
              }
            </div>
          </div>
        </div>

        <div className="products-block-3">

          <div className="container">
            <div className="title">
              <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-3/arrow.png`} alt="" className="arrow" />
              { productData.block_3.title }
            </div>
            <div className="undertitle">
            { productData.block_3.undertitle }
            </div>
            <Link to="/find-an-agent" className='action-btn-link'>
              <button className='action-btn button-gradient'>
                Find an Agent
              </button>
            </Link>
          </div>

        </div>

        <div className="products-block-4">
          <div className="container">
            <div className="title">
              { productData.block_4.title }
            </div>
            <div className="undertitle">
              { productData.block_4.undertitle }
            </div>
            <div className="damages-block">
              {
                productData.block_4.block_4_1.map(item => {
                  return <div className="damage" key={item.id}>
                    <img src={item.img} alt="" />
                    {item.text}
                  </div>
                })
              }
            </div>
          </div>
        </div>

        <div className="common-questions products-block-5">
          <div className="container">
            <div className={`title ${questionsStore.commonQuestionsList.length > 0 ? '' : 'hidden'}`}>Common Questions</div>
            {
              questionsStore.commonQuestionsList.map(item => {
                return <ul className='question-block' key={item.id}>
                  <li className='question-line' onClick={(ev) => toggleOpen(ev.target)}>
                    <div>
                      <div className="question">
                        <div className="number">{questionsStore.commonQuestionsList.indexOf(item) + 1}</div>
                        {item.question}
                      </div>
                    </div>
                    <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/arrow-dropdown.png`} alt="" className={`arrow ${ item.isOpened ? 'turned' : '' }`} />
                  </li>
                  <li
                    className={`answer-line ${item.isOpened ? 'opened' : '' }`}
                  >
                    <div className="answer">
                      {parser(item.answer)}
                    </div>
                  </li>
                </ul>
              })
            }
            <div className="common-questions-text-link">
              Still have a question? Visit our <Link to="/info-center">Info Center</Link>
            </div>

            <div className="disclaimer">
              { productData.block_5.text2 }
            </div>

            <div className="navigation-block">

              {
                productData.block_5.previousPage &&
                <div className="previous-block">
                  <div className="previous-label">
                    { productData.block_5.previousLabel }
                  </div>

                  <div className="previous-page">
                    <Link
                        to={productData.block_5.previousPage.url}
                    >
                      { productData.block_5.previousPage.title }
                    </Link>
                  </div>
                </div>
              }

              {
                productData.block_5.nextPage &&
                <div className="next-block">
                  <div className="next-label">
                    { productData.block_5.nextLabel }
                  </div>

                  <div className="next-page">
                    <Link
                        to={productData.block_5.nextPage.url}
                    >
                      { productData.block_5.nextPage.title }
                    </Link>
                  </div>
                </div>
              }

            </div>


          </div>
        </div>

      </div>
    </>
  );
}
